import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auth } from '../../../components/Auth/Auth.jsx';

const updateProjectId = async ({ shopId, projectId }) => {
  if (!projectId || !shopId) {
    throw new Error("No project ID or Shop ID found!");
  }
  
  const user = auth.currentUser;
  if (!user) {
    throw new Error("No authenticated user found");
  }

  const token = await user.getIdToken();

  
  const response = await fetch(`${import.meta.env.VITE_API_URL}/api/v2/shop/project`, {
    method: 'PATCH', 
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
   
    body: JSON.stringify({shopId, projectId: projectId }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Network response was not ok');
  }

  return response.json();
};

export const useProjectIdData = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateProjectId,
        onSuccess: (data) => {
            console.log('Project ID updated successfully:', data);
            
            queryClient.invalidateQueries({ queryKey: ['AllShops'] });
        },
        onError: (error) => {
            console.error('Failed to update Project ID:', error);
            
        },
    });
};